import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetDossierDataCommand } from '@/app/dossier/commands/get-dossier-data.command'
import { CreateDossierCommand } from '@/app/dossier/commands/create-dossier.command'

const httpClient = new AxiosClient()

export const getDossierDataCommand = new GetDossierDataCommand(httpClient, store)
export const createDossierCommand = new CreateDossierCommand(httpClient, store)
